import { notEmpty } from '@ember/object/computed';

import StorageObject from 'ember-local-storage/local/object';

const Storage = StorageObject.extend({
  isAuthenticated: notEmpty('token'),
});

Storage.reopenClass({
  initialState() {
    return {};
  },
});

export default Storage;
